import { parseJson, oz } from '@weft/utils';

export const StringArrayParamSchema = oz.string().transform(s => parseJson<string[]>(s)).pipe(oz.string().array());